let formatAmountPlugin = {
  install (Vue, options) {
    /** 数值单位转换 */
    Vue.prototype.formatAmount = function (totalAmount, nullText) {
      if (totalAmount) {
        let totalAmountStr = totalAmount + ''
        let totalAmountStrLength = totalAmountStr.substring(0, totalAmountStr.indexOf('.')).length
        if (totalAmountStr.indexOf('.') === -1) {
          totalAmountStrLength = totalAmountStr.length
        }
        totalAmount = parseFloat(totalAmountStr)
        // console.log(totalAmountStr.indexOf('.'))
        if (totalAmount < 0) {
          if (totalAmountStrLength > 9) {
            totalAmount = (totalAmount / 100000000).toFixed(2) + '亿'
          } else if (totalAmountStrLength > 5) {
            totalAmount = (totalAmount / 10000).toFixed(2) + '万'
          } else {
            totalAmount = totalAmount.toFixed(2)
          }
        } else {
          if (totalAmountStrLength > 8) {
            totalAmount = (totalAmount / 100000000).toFixed(2) + '亿'
          } else if (totalAmountStrLength > 4) {
            totalAmount = (totalAmount / 10000).toFixed(2) + '万'
          } else {
            totalAmount = totalAmount.toFixed(2)
          }
        }
        return totalAmount
      } else if (totalAmount === 0) {
        return 0
      } else {
        return nullText
      }
    }
    /** 数字格式化 */
    Vue.prototype.toThousands = function (num, n, s) {
      let isDoubleFlag = false
      if (String(num).indexOf('-') !== -1) {
        isDoubleFlag = true
        num = String(num).slice(1, String(num).length)
      }
      num = (num / n).toFixed(s)
      num = (num || 0).toString()
      let arr = num.split('.')
      let l = arr[0].split('').reverse()
      let r = arr[1]
      let t = ''
      let result = ''
      for (let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
      }
      result = t.split('').reverse().join('') + '.' + r
      if (isDoubleFlag) {
        return '-' + result
      } else {
        return result
      }
    }
    /** 阿拉伯数字转为中文数字 */
    Vue.prototype.toChinesNum = function (num) {
      let changeNum = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      let unit = ['', '十', '百', '千', '万']
      num = parseInt(num)
      let getWan = (temp) => {
        let strArr = temp.toString().split('').reverse()
        let newNum = ''
        for (var i = 0; i < strArr.length; i++) {
          if (strArr.length === 1) {
            newNum = (i === 0 && strArr[i] === 0 ? '' : (i > 0 && strArr[i] === 0 && strArr[i - 1] === 0 ? '' : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i]))) + newNum
          } else if (strArr.length === 2) {
            newNum = (i === 0 && strArr[i] === 0 ? '' : (i > 0 && strArr[i] === 0 && strArr[i - 1] === 0 ? '' : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i]))) + newNum
            if (i === strArr.length - 1 && strArr[i] === '1') {
              newNum = newNum.slice(1)
            }
          } else {
            newNum = (i === 0 && strArr[i] === 0 ? '' : (i > 0 && strArr[i] === 0 && strArr[i - 1] === 0 ? '' : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i]))) + newNum
          }
        }
        return newNum
      }
      let overWan = Math.floor(num / 10000)
      let noWan = num % 10000
      if (noWan.toString().length < 4) {
        noWan = '0' + noWan
      }
      return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
    }
  }

}

export default formatAmountPlugin



// WEBPACK FOOTER //
// ./src/plugins/AmountFormatPlugin.js